export default {
  tags: 'برچسب‌ها',
  confirm: 'تایید',
  cancel: 'لغو',
  delete: 'حذف',
  restore: 'بازگردانی',
  edit: 'ویرایش',
  save: 'ذخیره',
  rename: 'ویرایش',
  move: 'تغییر مکان',
  paste: 'گذاشتن در این پوشه',
  addTag: 'افزودن برچسب',
  showDeleted: 'نمایش حذف شده ها ',
  hideDeleted: 'پنهان کردن حذف شده ها',
  hasNotSubTask: 'هیچ زیربرچسبی ندارد',
  title: 'عنوان',
  tagTitleExistsItWillMove:
    'برچسبی با این عنوان وجود دارد. در صورت تأیید به اینجا منتقل می‌شود.',
  couldNotRenameCauseItExists:
    'نمی‌توان به نام زیر تغییر داد چون این نام وجود دارد.',
  tagNames: 'برچسب‌های مورد نظر خود را وارد کنید',
  confirmDelete:
    'ایا مطمئن هستید که می‌خواهید این برچسب و تمام زیرم جموعه های آن حذف شود؟',
  order: 'ترتیب',

  movedSuccessfully(fileNames: string[], targetFolderName: string) {
    let message = 'انتقال';
    if (fileNames.length > 1) {
      message += ' برچسب‌های';
      for (const fileName of Object.values(fileNames)) {
        message += ` «${fileName}»,`;
      }
    } else {
      message += ` برچسب «${fileNames[0]} »`;
    }
    message += ` به برچسب ${targetFolderName}`;
    message += ' با موفقیت صورت گرفت';
    return message;
  },
  movedFailed(fileNames: string[], targetFolderName: string) {
    let message = 'در انتقال';
    if (fileNames.length > 1) {
      message += ' برچسب‌های';
      for (const fileName of Object.values(fileNames)) {
        message += ` «${fileName}»,`;
      }
    } else {
      message += ` برچسب «${fileNames[0]}»`;
    }
    message += ` به برچسب ${targetFolderName}`;
    message += ' مشکلی رخ داد. لطفا دوباره تلاش کنید.';
    return message;
  },
  General: 'کاربری عمومی',
  Identification: 'شناسنامه',
};
